// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3gszf","footer":"ModalUpdate_footer__kA1k3"};